// Mock data for LayerSeek DeFi Protocol Summit

export const eventDetails = {
  name: "LayerSeek DeFi Protocol Summit",
  date: "November 20th, 2026",
  targetDate: new Date("2026-11-20T13:00:00Z"),
  tagline: "Get 6 months of BD done in a single day.",
  headline: "Every Deal That Matters in DeFi Starts in This Room",
  subheadline: "Connect with founders, core teams, BD leads, growth, grants, and partnership teams from leading DeFi protocols. Walk away with deals, and relevant useful connections."
};

// Marketing highlights for hero section
export const marketingHighlights = [
  {
    icon: "DollarSign",
    title: "$5M+ in Grants",
    description: "Combined grants from ecosystem funds and foundations"
  },
  {
    icon: "Hammer",
    title: "Built for Builders",
    description: "Protocol teams, founders, and BD leads who ship"
  },
  {
    icon: "Zap",
    title: "1 Day = 6 Months BD",
    description: "Connect with several key contacts in a single day"
  }
];

export const heroStats = [
  { value: "100s", label: "DeFi Teams" },
  { value: "$5M+", label: "Grants Available" },
  { value: "7", label: "Speaker Sessions" },
  { value: "1:1", label: "Networking Tables" }
];

export const heroFeatures = [
  "No flights, hotels, or visas required",
  "B2B focused: partnerships, integrations, grants",
  "AI-powered matchmaking for relevant connections",
  "Interactive virtual venue, not a Zoom call"
];

export const sponsorLogos = [
  { name: "Placeholder 1", id: 1 },
  { name: "Placeholder 2", id: 2 },
  { name: "Placeholder 3", id: 3 },
  { name: "Placeholder 4", id: 4 },
  { name: "Placeholder 5", id: 5 },
  { name: "Placeholder 6", id: 6 }
];

export const whoIsItFor = [
  {
    title: "Protocol Teams",
    desc: "Ship integrations, land grants, find distribution partners.",
  },
  {
    title: "Founders & Co-founders",
    desc: "Raise, hire, acquire, get acquired.",
  },
  {
    title: "BD & Partnerships Teams",
    desc: "Close in a day what usually takes six months.",
  },
  {
    title: "Growth & Marketing Teams",
    desc: "Trade paid KOL spend for co-marketing that compounds.",
  },
  {
    title: "Chains, Foundations & Ecosystem Teams",
    desc: "Deploy grants, source builders worth funding, drive TVL.",
  },
  {
    title: "Infra, Tooling & Security Providers",
    desc: "Meet the protocols who need what you've built.",
  },
  {
    title: "Accelerators, Incubators & Capital Allocators",
    desc: "Find the next cohort. Write the check that gets there first.",
  },
];

export const venueFeatures = [
  {
    title: "Virtual Floor Layout",
    description: "Navigate a realistic conference floor with tables, booths, and lounges - just like a real venue.",
    icon: "Layout"
  },
  {
    title: "Main Stage",
    description: "Watch keynotes and panels from industry leaders on our immersive main stage.",
    icon: "Monitor"
  },
  {
    title: "Networking Tables",
    description: "Move between tables freely. Join conversations, meet new teams, or create your own table.",
    icon: "Users"
  },
  {
    title: "Sponsor Booths",
    description: "Dedicated areas for 1:1 conversations with sponsors and ecosystem partners.",
    icon: "Building2"
  },
  {
    title: "Breakout Rooms",
    description: "Topic-specific rooms for deep dives on DeFi lending, DEXs, bridges, security, and more.",
    icon: "DoorOpen"
  },
  {
    title: "1:1 Networking",
    description: "Schedule private meetings with specific protocols or teams you want to connect with.",
    icon: "UserCheck"
  },
  {
    title: "Live Q&A & Chat",
    description: "Engage with speakers in real-time. Ask questions, share insights, and connect.",
    icon: "MessageCircle"
  },
  {
    title: "AI Matchmaking",
    description: "Our AI recommends the most relevant protocols and people based on your goals.",
    icon: "Sparkles"
  }
];

// Extended networking table topics - comprehensive DeFi list
export const networkingTopics = [
  // Infrastructure & Core
  { id: 1, name: "Layer 1s", icon: "Layers", category: "infrastructure" },
  { id: 2, name: "Layer 2s", icon: "Layers", category: "infrastructure" },
  { id: 3, name: "Layer 3s", icon: "Layers", category: "infrastructure" },
  { id: 4, name: "Bridges", icon: "Link2", category: "infrastructure" },
  { id: 5, name: "Cross-Chain", icon: "ArrowLeftRight", category: "infrastructure" },
  { id: 6, name: "Chain Abstraction", icon: "Boxes", category: "infrastructure" },
  { id: 7, name: "Rollups", icon: "Database", category: "infrastructure" },
  { id: 8, name: "Data Availability", icon: "HardDrive", category: "infrastructure" },
  { id: 9, name: "RPC Providers", icon: "Radio", category: "infrastructure" },
  // Trading & Liquidity
  { id: 10, name: "DEXes", icon: "ArrowUpDown", category: "trading" },
  { id: 11, name: "CEXes", icon: "Building", category: "trading" },
  { id: 12, name: "Liquidity Providers", icon: "Droplets", category: "trading" },
  { id: 13, name: "Market Makers", icon: "TrendingUp", category: "trading" },
  { id: 14, name: "Perps & Derivatives", icon: "LineChart", category: "trading" },
  { id: 15, name: "Options Protocols", icon: "GitBranch", category: "trading" },
  { id: 16, name: "Aggregators", icon: "Combine", category: "trading" },
  { id: 17, name: "Intent Networks", icon: "Target", category: "trading" },
  { id: 18, name: "Liquidation Bots", icon: "Bot", category: "trading" },
  // DeFi Protocols
  { id: 19, name: "Lending & Borrowing", icon: "Wallet", category: "defi" },
  { id: 20, name: "Yield Platforms", icon: "PiggyBank", category: "defi" },
  { id: 21, name: "Stablecoins", icon: "DollarSign", category: "defi" },
  { id: 22, name: "Liquid Staking", icon: "Droplet", category: "defi" },
  { id: 23, name: "Restaking", icon: "RotateCw", category: "defi" },
  { id: 24, name: "RWA Protocols", icon: "Building2", category: "defi" },
  { id: 25, name: "Launchpads", icon: "Rocket", category: "defi" },
  { id: 26, name: "Prediction Markets", icon: "TrendingUp", category: "defi" },
  // Oracles & Data
  { id: 27, name: "Price Feeds", icon: "BarChart3", category: "oracles" },
  { id: 28, name: "Oracle Networks", icon: "Radio", category: "oracles" },
  { id: 29, name: "On-chain Data", icon: "Database", category: "oracles" },
  { id: 30, name: "Index Providers", icon: "List", category: "oracles" },
  { id: 31, name: "Analytics & Attribution", icon: "BarChart3", category: "oracles" },
  // Security & Audits
  { id: 32, name: "Smart Contract Audits", icon: "Shield", category: "security" },
  { id: 33, name: "Bug Bounties", icon: "Bug", category: "security" },
  { id: 34, name: "Insurance", icon: "Umbrella", category: "security" },
  { id: 35, name: "Risk Management", icon: "AlertTriangle", category: "security" },
  { id: 36, name: "Custodians", icon: "Shield", category: "security" },
  { id: 37, name: "Multi-sig Infra", icon: "Shield", category: "security" },
  // Growth & Marketing
  { id: 38, name: "Marketing Partners", icon: "Megaphone", category: "growth" },
  { id: 39, name: "Marketing Analytics", icon: "BarChart3", category: "growth" },
  { id: 40, name: "Marketing Tools", icon: "Target", category: "growth" },
  { id: 41, name: "Quest Platforms", icon: "Trophy", category: "growth" },
  { id: 42, name: "Referral Systems", icon: "Users", category: "growth" },
  { id: 43, name: "Airdrop Tools", icon: "Gift", category: "growth" },
  // Wallets & Payments
  { id: 44, name: "Wallets", icon: "Wallet", category: "wallets" },
  { id: 45, name: "Account Abstraction", icon: "UserCog", category: "wallets" },
  { id: 46, name: "Payment Rails", icon: "CreditCard", category: "wallets" },
  { id: 47, name: "Onramp & Offramp", icon: "ArrowUpDown", category: "wallets" },
  { id: 48, name: "Neobanks", icon: "Building", category: "wallets" },
  { id: 49, name: "Web3 Payroll FinTech", icon: "DollarSign", category: "wallets" },
  // Identity & Compliance
  { id: 50, name: "Identity / KYC Layers", icon: "UserCog", category: "compliance" },
  { id: 51, name: "ZK Proof of Identity", icon: "Shield", category: "compliance" },
  { id: 52, name: "Privacy Layer", icon: "Shield", category: "compliance" },
  { id: 53, name: "Legal / Compliance Firms", icon: "Shield", category: "compliance" },
  { id: 54, name: "Web3 Accounting", icon: "Database", category: "compliance" },
  // DeFAI - DeFi AI
  { id: 55, name: "DeFAI Agents", icon: "Bot", category: "defai" },
  { id: 56, name: "AI Trading Bots", icon: "Cpu", category: "defai" },
  { id: 57, name: "AI Analytics", icon: "Brain", category: "defai" },
  { id: 58, name: "Autonomous Agents", icon: "Zap", category: "defai" },
  // Institutional
  { id: 59, name: "Institutions", icon: "Building2", category: "institutional" },
  { id: 60, name: "Open Networking", icon: "Users", category: "general" },
];

// Category labels for display
export const topicCategories = {
  infrastructure: { label: "Infrastructure", color: "blue" },
  trading: { label: "Trading & Liquidity", color: "green" },
  defi: { label: "DeFi Protocols", color: "purple" },
  oracles: { label: "Oracles & Data", color: "orange" },
  security: { label: "Security & Audits", color: "red" },
  growth: { label: "Growth & Marketing", color: "pink" },
  wallets: { label: "Wallets & Payments", color: "cyan" },
  compliance: { label: "Identity & Compliance", color: "yellow" },
  defai: { label: "DeFAI", color: "violet" },
  institutional: { label: "Institutional", color: "blue" },
  general: { label: "General", color: "gray" },
};

export const aiMatchmakingFeatures = [
  {
    title: "Smart Profile Matching",
    description: "Our algorithm pairs you based on complementary interests, goals, and opportunities - not random connections."
  },
  {
    title: "Personalized Recommendations",
    description: "Get a customized list of connections with profiles, insights, and reasons why each match matters."
  },
  {
    title: "Easy Table Invites",
    description: "Locate matches within the venue, join their table with a click, or invite them to yours."
  },
  {
    title: "Conversation Starters",
    description: "Personalized talking points and ice breakers for every recommended connection - network with confidence."
  }
];

export const opportunities = [
  {
    title: "B2B Integrations",
    description: "Connect with wallets, bridges, infra providers, and chains to expand your protocol's reach.",
    icon: "Link"
  },
  {
    title: "Co-Marketing Partnerships",
    description: "Find protocols for Spaces, AMAs, joint campaigns, and community cross-pollination.",
    icon: "Megaphone"
  },
  {
    title: "Ecosystem Grants",
    description: "Millions in combined grants available. Discover builder programs, incubations, and funding pathways.",
    icon: "Wallet"
  },
  {
    title: "Media & Distribution",
    description: "Gain visibility and awareness through strategic partnerships and media collaborations.",
    icon: "Globe"
  },
  {
    title: "DeFi Tooling & Security",
    description: "Find analytics, security auditors, growth tools, and infrastructure to improve your protocol.",
    icon: "Shield"
  },
  {
    title: "Natural Networking",
    description: "Move freely between tables, just like at a real event. 3.2x higher engagement than typical virtual meetings.",
    icon: "ArrowRightLeft"
  }
];

export const agendaItems = [
  {
    time: "12:00 PM - 12:30 PM UTC",
    title: "Opening Keynote",
    type: "Keynote",
    description: "Welcome to LayerSeek DeFi Protocol Summit - vision for DeFi collaboration in 2026."
  },
  {
    time: "12:30 PM - 1:30 PM UTC",
    title: "Future of Building in DeFi",
    type: "Panel",
    description: "Leaders from top protocols discuss cross-chain collaboration and integration strategies."
  },
  {
    time: "1:30 PM - 3:00 PM UTC",
    title: "Networking Block #1",
    type: "Networking",
    description: "Open networking on the virtual floor. Visit sponsor booths and meet protocol teams."
  },
  {
    time: "3:00 PM - 3:30 PM UTC",
    title: "Protocol Demos",
    type: "Demo",
    description: "5-minute rapid demos from innovative DeFi protocols and infrastructure providers."
  },
  {
    time: "3:30 PM - 4:00 PM UTC",
    title: "Break",
    type: "Break",
    description: "Grab a coffee, stretch, and reset before the second half of the summit."
  },
  {
    time: "4:00 PM - 7:30 PM UTC",
    title: "Networking Block #2",
    type: "Networking",
    description: "Extended networking block. AI-powered matchmaking active. Meet your recommended protocol partners across the venue floors."
  },
  {
    time: "7:30 PM - 8:00 PM UTC",
    title: "Fireside Chat: Building DeFi Partnerships",
    type: "Fireside",
    description: "Insights from BD leads who have scaled partnerships across the ecosystem."
  },
  {
    time: "8:00 PM - 11:30 PM UTC",
    title: "Final Networking & Closing",
    type: "Networking",
    description: "Last chance to connect. Exchange contacts and set up follow-up meetings."
  }
];

export const ticketTiers = [
  {
    name: "Solo Attendee",
    subtitle: "Protocol Representative",
    earlyBird: 297,
    fourteenDays: 349,
    seventyTwoHours: 397,
    features: [
      "Full event access (all 9 floors)",
      "AI-powered matchmaking",
      "All networking sessions",
      "All keynotes & panels",
      "1-to-1 private conversations",
      "Contact exchange & follow-up"
    ],
    highlight: false,
    cta: "Get Your Ticket"
  }
];

export const sponsorTiers = [
  {
    name: "Silver Sponsor",
    subtitle: "Best for Core Teams",
    earlyBird: 997,
    thirtyDays: 1149,
    fourteenDays: 1297,
    features: [
      "1 dedicated table",
      "Up to 3 team members",
      "Embed website, videos & pitch decks",
      "Host surveys for booth visitors",
      "1-to-1 and 1-to-many conversations",
      "Full event access + AI matchmaking",
      "Mentions across socials & banners",
    ],
    highlight: true,
    cta: "Apply Now"
  },
  {
    name: "Gold Sponsor",
    subtitle: "Limited to 5 Sponsors",
    earlyBird: 2497,
    thirtyDays: 2997,
    fourteenDays: 3497,
    features: [
      "3 dedicated tables",
      "Up to 6 team members",
      "Embed content on 2 tables",
      "Host surveys for booth visitors",
      "1-to-1 and 1-to-many conversations",
      "Full event access + AI matchmaking",
      "1x 5-min speaker slot",
      "All marketing mentions & banners",
    ],
    highlight: false,
    cta: "Apply Now"
  },
  {
    name: "Diamond Sponsor",
    subtitle: "Ecosystems & Foundations",
    earlyBird: 8497,
    thirtyDays: 9797,
    fourteenDays: 10997,
    features: [
      "Entire dedicated floor",
      "Up to 10 ecosystem team members",
      "8-10 booths for featured protocols",
      "Embed content on 10 tables",
      "Host surveys for booth visitors",
      "1-to-1 and 1-to-many conversations",
      "Full event access + AI matchmaking",
      "All marketing mentions + banners",
    ],
    highlight: false,
    cta: "Apply Now"
  }
];

export const trueKolBenefits = [
  "Know true KOL collaboration costs",
  "Avoid overpaying for partnerships",
  "Budget accurately for campaigns",
  "Access verified pricing data"
];

export const faqItems = [
  {
    question: "Is this event recorded?",
    answer: "No, LayerSeek is designed for live participation only. This ensures genuine networking and real-time collaboration. There will be no full recordings to maintain the exclusivity and value of live attendance."
  },
  {
    question: "Who should attend LayerSeek?",
    answer: "LayerSeek is built for DeFi protocol teams, founders, BD/partnerships leads, growth teams, ecosystem teams, and infrastructure providers. If you're looking for B2B integrations, co-marketing, grants, or strategic partnerships in DeFi, this is for you."
  },
  {
    question: "What if I want to sponsor the event?",
    answer: "We offer Silver, Gold, and Diamond sponsorship tiers with dedicated booths, speaker slots, and marketing visibility. Silver is great for teams of 3, Gold for larger teams wanting scale, and Diamond for ecosystems and foundations wanting a dedicated section."
  },
  {
    question: "How do dedicated booths and tables work?",
    answer: "Sponsors receive branded booth areas on the virtual floor. Attendees can visit your booth for 1:1 conversations. You can staff your booth with team members and have private conversations with potential partners."
  },
  {
    question: "How does AI matchmaking work?",
    answer: "When you register, you'll select what you're looking for (integrations, grants, co-marketing, etc.). Our AI analyzes all attendees and recommends the most relevant protocols and people. You'll receive suggestions for tables and rooms where your ideal matches are networking."
  },
  {
    question: "Can I attend from anywhere in the world?",
    answer: "Yes! LayerSeek is fully virtual. Join from anywhere with an internet connection. No flights, hotels, or visas required. The event runs in UTC timezone with networking blocks spread throughout the day."
  },
  {
    question: "What is TrueKOL and how do I access it?",
    answer: "TrueKOL is a Web3 KOL database with 2,500+ influencers, their direct contacts, and true collaboration costs. Normally $997/year, sponsors receive complimentary access: Silver (7 days), Gold (30 days), Diamond (60 days)."
  }
];

// Guest experience features from Remo
export const guestFeatures = [
  {
    title: "Free Movement",
    description: "Move between tables and spaces freely - no forced breakout rooms. Network at your own pace.",
    icon: "Move"
  },
  {
    title: "HD Video & Audio",
    description: "Crystal-clear 1080p video for face-to-face conversations that feel as real as in-person.",
    icon: "Video"
  },
  {
    title: "Live Reactions",
    description: "Express yourself with reactions, emojis, and GIFs. Keep conversations engaging and fun.",
    icon: "Smile"
  },
  {
    title: "Screen Sharing",
    description: "Share your deck, demo, or docs with multiple people at your table simultaneously.",
    icon: "Monitor"
  },
  {
    title: "Virtual Business Cards",
    description: "Customizable profiles with your photo, role, and what you're looking for at the event.",
    icon: "CreditCard"
  },
  {
    title: "Direct Messaging",
    description: "Send private messages to any attendee. Schedule follow-up meetings during the event.",
    icon: "MessageSquare"
  }
];